export default "__VITE_ASSET__Rw1xfNYV__"